module.exports = __webpack_public_path__ + "static/media/question-mark.48203d3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/creator/icons/arrows/question-mark.svg
// module id = 64
// module chunks = 0